export class EligibilityCodeValidationModel {
  public isValid?: boolean;
  public siteError?: SiteError;
  public dataToSet?: EligibilityCodeValidationDataToSetModel;
}

export class EligibilityCodeValidationDataToSetModel {
  public eligibilityCode: string;
  public partnerOfferId: string;
  public partnerOfferDetails: string;
}

export class SiteError {
  public reasonCode: string; // code
  public description: string; // api's description
}

export class EligibilityValidationRequest {
  public webId: string;
  public eligibilityCode: string;
  public firstName?: string;
  public lastName?: string;
  public validationSource: string;
}

export enum EligibilityValidation {
  NoValidation = 'None',
  UpfrontValidation = 'Upfront',
  SignupValidation = 'Signup',
  CaptureOnly = 'CaptureOnly'
}

export enum EligibilityValidationSource {
  Sap = 'SAP',
  Velocity = 'Velocity'
}

export enum EligibilityValidationSourceWithPromoCodeDls {
  Velocity = 'Velocity'
}
